import { BaseButtonAction } from './BaseButtonAction';

export class OutlinesButtonAction extends BaseButtonAction {}
